import { Link } from 'react-router';
import { ArrowRight } from 'lucide-react';

function LandingPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white font-sans text-[#0E0E10] antialiased">
      <header className="flex h-16 items-center border-b border-[#EDEDEA] px-8 max-[560px]:px-5">
        <Link
          to="/"
          aria-label="Dff Flow home"
          className="inline-flex items-baseline gap-[7px] leading-none no-underline"
        >
          <span className="text-[22px] font-bold tracking-[-0.02em] text-[#1B2A66]">
            Dff
          </span>
          <span className="text-[22px] font-normal tracking-[-0.01em] text-[#6B6B74]">
            Flow
          </span>
        </Link>
      </header>

      <main className="flex flex-1 items-center justify-center px-8 py-12 max-[560px]:px-5">
        <div className="w-full max-w-[460px] text-center">
          <span className="mb-6 inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.08em] text-[#6B6B74]">
            <span className="size-1.5 rounded-full bg-brand-navy" />
            Investor Portal
          </span>

          <h1 className="text-[40px] font-bold leading-[1.1] tracking-[-0.025em] text-[#0E0E10] max-[560px]:text-[32px]">
            Welcome to Dff&nbsp;Flow.
          </h1>

          <p className="mx-auto mt-4 max-w-[400px] text-base leading-normal text-[#6B6B74]">
            Sign in to view your commitments, capital calls, distributions, and
            portfolio performance.
          </p>

          <div className="mt-9 flex justify-center">
            <Link
              to="/portal/login"
              aria-label="Go to investor login"
              className="group inline-flex h-[52px] items-center gap-3 rounded-full bg-brand-navy pl-[26px] pr-[18px] text-base font-bold tracking-[0.01em] text-white no-underline transition-colors hover:bg-[#0A1D52] active:translate-y-px active:bg-[#020B26]"
            >
              <span>Investor Login</span>
              <span className="inline-flex size-[30px] items-center justify-center rounded-full bg-white/15 transition-transform group-hover:translate-x-[3px]">
                <ArrowRight className="size-4" />
              </span>
            </Link>
          </div>

          <p className="mt-5 text-[13px] text-[#6B6B74]">
            Need access?{' '}
            <a
              href="mailto:support@dff.ventures"
              className="border-b border-[#D4D4CE] pb-px text-[#3C3C43] no-underline transition-colors hover:border-brand-navy hover:text-brand-navy"
            >
              Contact your fund manager
            </a>
          </p>

          <p className="mt-2.5 text-[13px] text-[#6B6B74]">
            Fund manager?{' '}
            <Link
              to="/auth/login"
              className="group inline-flex items-center gap-1 font-semibold text-brand-navy no-underline"
            >
              Admin login
              <ArrowRight className="size-3.5 transition-transform group-hover:translate-x-[3px]" />
            </Link>
          </p>
        </div>
      </main>

      <footer className="flex items-center justify-between border-t border-[#EDEDEA] px-8 py-[18px] text-xs text-[#A4A4AB] max-[560px]:px-5">
        <span>© 2026 DFF Ventures B.V.</span>
        <span>Amsterdam · Milan · Cape Town</span>
      </footer>
    </div>
  );
}

export default LandingPage;
